module.exports = __webpack_public_path__ + "img/quizck.83a039f1.svg";